export const PlayIcon = ({ color }) => {
  return (
    <path
      d="M8.5 16.4443V7.55576C8.5 7.29176 8.59042 7.07509 8.77125 6.90576C8.95192 6.73659 9.16283 6.65201 9.404 6.65201C9.48083 6.65201 9.56025 6.66292 9.64225 6.68476C9.72442 6.70642 9.80392 6.73909 9.88075 6.78276L16.8767 11.2365C17.0141 11.3302 17.117 11.4423 17.1855 11.573C17.2542 11.7038 17.2885 11.8462 17.2885 12C17.2885 12.1538 17.2542 12.2962 17.1855 12.427C17.117 12.5577 17.0141 12.6698 16.8767 12.7635L9.88075 17.2173C9.80392 17.2609 9.72442 17.2936 9.64225 17.3153C9.56025 17.3371 9.48083 17.348 9.404 17.348C9.16283 17.348 8.95192 17.2634 8.77125 17.0943C8.59042 16.9249 8.5 16.7083 8.5 16.4443Z"
      fill={color}
    />
  )
}
